import type { IReservation, Reservation, User } from '@curbnturf/objects';
import { DateTime } from 'luxon';

export const generateReservationConfirmationCode = (reservation: IReservation): string => {
  return `r-${reservation.id}`;
};

export const getCancellationPolicyString = (cancellationPolicy: string): string => {
  switch (cancellationPolicy) {
    case 'easy': {
      return `Cancel up to one day prior to check-in to get a full refund. Any early check-outs will receive a full refund for all nights falling 24 hours after cancellation.`;
    }
    case 'moderate': {
      return `Cancel up to three days prior to check-in to get a full refund. Any early check-outs will receive a half refund for all nights falling 24 hours after cancellation.`;
    }
    case 'strict': {
      return `Cancel up to seven days prior to check-in to get a half refund. There are no refunds for early check-outs.`;
    }
    case 'exclusive': {
      return 'Any cancellation is non-refundable. There are no refunds for early check-outs.';
    }
    default:
      return '';
  }
};

export function lastDayToCancel(reservation: Reservation): DateTime | false {
  if (reservation.site?.listing) {
    let cancelDaysInAdvance;
    switch (reservation.site.listing.cancellationPolicy as string) {
      case 'exclusive': {
        return false;
      }
      case 'strict': {
        cancelDaysInAdvance = 7;
        break;
      }
      case 'moderate': {
        cancelDaysInAdvance = 3;
        break;
      }
      case 'easy':
      default: {
        cancelDaysInAdvance = 1;
      }
    }

    if (reservation.date && reservation.date.from) {
      let latestCancellableDate = DateTime.fromISO(reservation.date.from);
      latestCancellableDate = latestCancellableDate.minus({ day: cancelDaysInAdvance });
      return latestCancellableDate;
    }
  }
  return false;
}

export function isReservationCancellable(reservation: Reservation, currentUser: User): boolean {
  return Boolean(currentUser?.id && reservation.cancellable(currentUser?.id));
}
